/* eslint-disable @typescript-eslint/no-explicit-any */
import { httpApi } from '@app/api/http.api';
import { BlogModel } from '@app/model/BlogModel';

export const getBlogsApi = (): Promise<BlogModel[]> =>
  httpApi.get<BlogModel[]>('blogs').then(({ data }: any) => data);

  export const getBlogApi = (uuid: string): Promise<BlogModel> =>
  httpApi.get<BlogModel>(`blogs/${uuid}`).then(({ data }: any) => data);
